// extracted by mini-css-extract-plugin
export default {"wrapper":"RelatedMessages_wrapper_b5Asx","messages":"RelatedMessages_messages_UWIr_","write":"RelatedMessages_write_prqGP","message":"RelatedMessages_message_y6DQs"};